import {useState} from 'react';
import {useSelector} from 'react-redux';
import {Grid, Container, Header, Image, Message} from 'semantic-ui-react';

import {sitesTypeInfo} from 'components/Common/sharedElements';
import httpClient from 'httpClient';
import {getPaaSSiteManagementLink} from 'state/selectors';
import paasIcon from 'static/paas_icon.png';

import PaaSCreationForm from './PaaSCreationForm';

import styles from './PaaSCreation.module.scss';

const PaaSCreation = () => {
  const [showForm, setShowForm] = useState(true);
  const [creationError, setCreationError] = useState(null);
  const [projectName, setProjectName] = useState('');
  const paasSiteManagementLink = useSelector(getPaaSSiteManagementLink);

  const createPaaSProject = async newProjectData => {
    setCreationError(null);
    try {
      await httpClient.post('/api/paas/projects', newProjectData, {handleErrorsCentrally: false});
      setProjectName(newProjectData.name);
      setShowForm(false);
    } catch (err) {
      let creationErrorMessage = '';
      if (err.response.data.errors) {
        creationErrorMessage += err.response.data.errors.json;
      }
      if (err.response.data.error) {
        creationErrorMessage += err.response.data.error;
      }
      setCreationError(creationErrorMessage);
    }
  };

  return (
    <Grid centered>
      <Grid.Column className={styles.PaaSCreation}>
        <Container>
          <Header as="h3" className={styles.Header}>
            <Image src={paasIcon} alt="PaaS icon" className={styles.HeaderIcon} /> Creating a PaaS
            Project
          </Header>
          {showForm ? (
            <div>
              <p>You're minutes away from getting your PaaS project.</p>
            </div>
          ) : (
            <div>
              <p>The project has been created.</p>
              <p>
                You can manage it through the{' '}
                <a
                  href={new URL(`${paasSiteManagementLink}/${projectName}`).toString()}
                  target="_blank"
                  rel="noreferrer"
                >
                  OKD console
                </a>
                .
              </p>
              <p>
                Please follow{' '}
                <a
                  href={sitesTypeInfo['paas']['documentationUrl']}
                  target="_blank"
                  rel="noreferrer"
                >
                  paas
                </a>{' '}
                configuration instructions to finalize the setup of your application.
              </p>
            </div>
          )}
        </Container>
        {creationError && (
          <Message negative>
            <Message.Header>There was a problem creating the project</Message.Header>
            <p>{creationError}</p>
            <p>
              Please try again or open a{' '}
              <a
                href="https://cern.service-now.com/service-portal?id=service_element&name=web-portal"
                target="_blank"
                rel="noreferrer"
              >
                ticket
              </a>
            </p>
          </Message>
        )}
        {showForm && <PaaSCreationForm create={createPaaSProject} />}
      </Grid.Column>
    </Grid>
  );
};

export default PaaSCreation;
